import { mainRoutes } from "../routes"
import { UserFeatures } from "./common";

export default function isAuthenticated(path) {
    let selectedRoute = mainRoutes.find(a => a.path === path);
    let isAllowed = UserFeatures.get()?.some((a) => a.featureId === selectedRoute.id);
    return isAllowed;
}
